<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 搜索框 -->
		<div class="titleView">
			<div style="flex: 1;display: flex;justify-content: flex-end;">
				<el-button class="addClick" @click="drawerUpdate_state = true;navType = 1" size="small">新建活动</el-button>
			</div>
		</div>

		<!-- 表格 -->
		<div class="tableView">
			<el-table :data="tableData" style="width: 100%;">
				<el-table-column prop="name" label="活动名称">
				</el-table-column>
				<el-table-column label="累积金额">
					<template slot-scope="scope">
						{{scope.row.min_money}}-{{scope.row.max_money}}
					</template>
				</el-table-column>
				<el-table-column label="购买折扣(折)">
					<template slot-scope="scope">
						{{scope.row.discount * 10}}
					</template>
				</el-table-column>
				<el-table-column prop="add_info.user_name" label="操作人">
				</el-table-column>
				<el-table-column prop="name" label="操作时间">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.add_info.create_time,'YYYY-MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="handleEditClick(scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<page :page="page.page" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>	
		</div>
		<!-- 新建/编辑 -->
		<div v-if="drawerUpdate_state">
			<drawerUpdate @closeOn="handleUpdatClose" :comState="drawerUpdate_state" :navData="navData" :navType="navType"></drawerUpdate>
		</div>
	</div>
</template>

<script>
	import page from "../../components/page.vue"
	import drawerUpdate from "./drawerUpdate.vue"
	export default {
		components: {
			page,
			drawerUpdate
		},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				fixedHeight: '',
				tableData: [], //表格数据
				navData:null,
				navType:0,
				drawerUpdate_state:false,
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 106;
			this.getTableData()
		},
		methods: {
			//编辑
			handleEditClick(row){
				this.navData = row;
				this.navType = 2;
				this.drawerUpdate_state = true;
			},
			//删除卡号
			handleDeleteClick(row){
				console.log(row)
				this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(row)
					let params = {
						id:row._id,
						name:row.name
					}
					this.$http.get(process.env.VUE_APP_Url6 + 'api/GiftCardActivity/Delete', params)
						.then(res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '已删除'
								})
								this.getTableData()
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
				
			},
			//关闭绑定用户
			handleUpdatClose(val){
				this.drawerUpdate_state = false;
				if(val.type == "submit"){
					this.getTableData()
				}
			},
			//获取表格
			getTableData(){
				console.log(this.date)
				let params = {
					page_index:this.page.page,
					page_size:this.page.pageSize,
					status:1,
				}
				console.log(params)
				this.$http.post(process.env.VUE_APP_Url6 + 'api/GiftCardActivity/GetList', params)
					.then(res => {	
						if (res.code == 0) {
							console.log('卡号列表', res.data.data)
							this.tableData = res.data.data;
							this.page.total = res.data.count;
						}
					})
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
		},
		
	}
</script>

<style lang="scss" scoped>
	.titleView {
		height: 70px;
		line-height: 70px;
		display: flex;
		background: #fff;
		align-items: center;
		border-radius: 6px;
		margin-bottom: 10px;
		font-size: 12px;
		padding: 0 10px;

		.titleInput {
			width: 130px;
		}

		.titleDate {
			width: 260px;
		}

		.titleSelect {
			width: 100px;
		}
	}

	.flex {
		display: flex;
		align-items: center;
		margin-left: 10px;
	}

	.m-r-10 {
		margin-right: 10px;
		font-size: 12px;
	}

	.tableView {
		height: calc(100% - 80px);
		background: #fff;
	}
</style>
